export default "__VITE_ASSET__Cit1V0ac__"